export enum BuyerTypes {
  OWNER_OCCUPIER = "Owner Occupier",
  INVESTOR = "Investor",
}
